(function () {
  function parseJsonScript(script) {
    if (!script || !script.textContent) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getMediaItems(media) {
    return Array.from(media.querySelectorAll('[data-dd-pdp-media-item]'));
  }

  function showAllMedia(media) {
    if (!media) return;

    media.removeAttribute('data-dd-active-media-id');
    media.removeAttribute('data-dd-active-media-start');
    media.removeAttribute('data-dd-active-media-end');
    media.classList.remove('is-expanded');
    media.classList.remove('dd-pdp-media--collapsed');

    getMediaItems(media).forEach(function (item) {
      item.classList.remove('is-hidden-by-limit');
      item.classList.remove('is-active');
      item.style.removeProperty('order');
    });

    var more = media.querySelector('[data-dd-pdp-media-more]');
    if (more) more.hidden = true;

    var hiddenCount = media.querySelector('[data-dd-pdp-hidden-count]');
    if (hiddenCount) hiddenCount.textContent = '0';

    var expandButton = media.querySelector('[data-dd-pdp-media-expand]');
    if (expandButton) expandButton.setAttribute('aria-expanded', 'false');

    updateMediaPagination(media);
  }

  function getOrderedMediaItems(media) {
    return getMediaItems(media).slice().sort(function (a, b) {
      var aOrder = Number.parseInt(a.style.order || a.dataset.ddOriginalIndex || '0', 10);
      var bOrder = Number.parseInt(b.style.order || b.dataset.ddOriginalIndex || '0', 10);

      if (aOrder !== bOrder) return aOrder - bOrder;

      return (
        Number.parseInt(a.dataset.ddOriginalIndex || '0', 10) -
        Number.parseInt(b.dataset.ddOriginalIndex || '0', 10)
      );
    });
  }

  function ensureMediaPagination(media) {
    if (!media) return null;

    var pagination = media.querySelector('[data-dd-pdp-media-pagination]');
    if (pagination) return pagination;

    pagination = document.createElement('div');
    pagination.className = 'dd-pdp-media__pagination';
    pagination.setAttribute('data-dd-pdp-media-pagination', '');
    pagination.setAttribute('aria-hidden', 'true');
    pagination.innerHTML =
      '<span data-dd-pdp-media-current>1</span><span>&nbsp;/&nbsp;</span><span data-dd-pdp-media-total>1</span>';

    media.appendChild(pagination);
    return pagination;
  }

  function updateMediaPagination(media) {
    var pagination = ensureMediaPagination(media);
    if (!pagination) return;

    var grid = media.querySelector('.dd-pdp-media__grid');
    var items = getOrderedMediaItems(media);
    var total = items.length;

    if (!grid || total < 2) {
      pagination.hidden = true;
      return;
    }

    var gridRect = grid.getBoundingClientRect();
    var viewportCenter = gridRect.left + gridRect.width / 2;
    var currentIndex = 0;
    var closestDistance = Infinity;

    items.forEach(function (item, index) {
      var itemRect = item.getBoundingClientRect();
      var itemCenter = itemRect.left + itemRect.width / 2;
      var distance = Math.abs(itemCenter - viewportCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        currentIndex = index;
      }
    });

    var current = pagination.querySelector('[data-dd-pdp-media-current]');
    var totalEl = pagination.querySelector('[data-dd-pdp-media-total]');

    if (current) current.textContent = String(currentIndex + 1);
    if (totalEl) totalEl.textContent = String(total);

    pagination.hidden = false;
  }

  function prioritizeMediaGroup(media, startIndex, endIndex) {
    var items = getMediaItems(media);
    var orderedItems = items.slice(startIndex, endIndex).concat(
      items.filter(function (_item, index) {
        return index < startIndex || index >= endIndex;
      })
    );

    orderedItems.forEach(function (item, index) {
      item.style.order = String(index);
    });
  }

  function getVariantMediaBoundaries(section, media) {
    var items = getMediaItems(media);
    var variants = parseJsonScript(section.querySelector('[data-dd-product-variants]')) || [];

    return variants
      .map(function (variant) {
        if (!variant || !variant.featured_media_id) return -1;

        return items.findIndex(function (item) {
          return item.dataset.mediaId === String(variant.featured_media_id);
        });
      })
      .filter(function (index, position, list) {
        return index > -1 && list.indexOf(index) === position;
      })
      .sort(function (a, b) {
        return a - b;
      });
  }

  function getMediaGroupBounds(section, media, mediaId) {
    var items = getMediaItems(media);
    var activeIndex = items.findIndex(function (item) {
      return item.dataset.mediaId === String(mediaId);
    });

    if (activeIndex < 0) {
      return {
        activeIndex: -1,
        start: 0,
        end: items.length,
      };
    }

    var boundaries = getVariantMediaBoundaries(section, media);

    if (!boundaries.length) {
      return {
        activeIndex: activeIndex,
        start: 0,
        end: items.length,
      };
    }

    var firstBoundary = boundaries[0];

    if (firstBoundary === 0) {
      var nextStart = boundaries.find(function (index) {
        return index > activeIndex;
      });

      return {
        activeIndex: activeIndex,
        start: activeIndex,
        end: nextStart === undefined ? items.length : nextStart,
      };
    }

    var previousEnd = -1;

    boundaries.some(function (index) {
      if (index >= activeIndex) return true;

      previousEnd = index;
      return false;
    });

    return {
      activeIndex: activeIndex,
      start: previousEnd + 1,
      end: activeIndex + 1,
    };
  }

  function applyMediaLimit(media) {
    if (!media) return;

    var activeMediaId = media.dataset.ddActiveMediaId;
    if (!activeMediaId) {
      showAllMedia(media);
      return;
    }

    var limit = Number.parseInt(media.dataset.ddMediaLimit || '6', 10);
    var items = getMediaItems(media);
    var isExpanded = media.classList.contains('is-expanded');

    if (!Number.isFinite(limit) || limit < 1) return;

    var orderedItems = getOrderedMediaItems(media);
    var visibleEndIndex = isExpanded ? orderedItems.length : Math.min(orderedItems.length, limit);
    var visibleCount = 0;

    orderedItems.forEach(function (item, index) {
      var isVisible = index < visibleEndIndex;
      item.classList.toggle('is-hidden-by-limit', !isVisible);
      item.classList.toggle('is-active', item.dataset.mediaId === activeMediaId);
      if (isVisible) visibleCount += 1;
    });

    var hiddenInGroup = Math.max(orderedItems.length - visibleCount, 0);
    var more = media.querySelector('[data-dd-pdp-media-more]');
    var hiddenCount = media.querySelector('[data-dd-pdp-hidden-count]');

    if (hiddenCount) {
      var nextHiddenCount = String(hiddenInGroup);
      if (hiddenCount.textContent !== nextHiddenCount) hiddenCount.textContent = nextHiddenCount;
    }

    if (more) more.hidden = hiddenInGroup < 1;

    updateMediaPagination(media);
  }

  function activateMediaItem(section, mediaId, smooth) {
    var media = section.querySelector('[data-dd-pdp-media]');
    var mediaGrid = section.querySelector('.dd-pdp-media__grid');

    if (!mediaId || !media || !mediaGrid) return;

    var bounds = getMediaGroupBounds(section, media, mediaId);
    if (bounds.activeIndex < 0) return;

    var targetItem = getMediaItems(media)[bounds.start];
    if (!targetItem) return;

    media.dataset.ddActiveMediaId = String(mediaId);
    media.dataset.ddActiveMediaStart = String(bounds.start);
    media.dataset.ddActiveMediaEnd = String(bounds.end);
    media.classList.remove('is-expanded');
    media.classList.add('dd-pdp-media--collapsed');
    prioritizeMediaGroup(media, bounds.start, bounds.end);

    applyMediaLimit(media);

    var expandButton = media.querySelector('[data-dd-pdp-media-expand]');
    if (expandButton) expandButton.setAttribute('aria-expanded', 'false');

    if (smooth && typeof mediaGrid.scrollTo === 'function') {
      mediaGrid.scrollTo({ left: targetItem.offsetLeft, behavior: 'smooth' });
    }

    if (smooth && typeof targetItem.scrollIntoView === 'function' && media.classList.contains('is-expanded')) {
      targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    [0, 100, 350].forEach(function (delay) {
      window.setTimeout(function () {
        updateMediaPagination(media);
      }, delay);
    });
  }

  function initDetails(section) {
    var trigger = section.querySelector('[data-dd-full-details-trigger]');
    var panel = section.querySelector('[data-dd-full-details-panel]');

    if (!trigger || !panel || trigger.dataset.ddDetailsInitialized === 'true') return;

    trigger.dataset.ddDetailsInitialized = 'true';

    trigger.addEventListener('click', function () {
      var isCollapsed = panel.classList.contains('dd-pdp-details--collapsed');

      if (isCollapsed) {
        panel.classList.add('is-expanded');
        panel.classList.remove('dd-pdp-details--collapsed');
        trigger.setAttribute('aria-expanded', 'true');

        var firstDetails = panel.querySelector('details');
        if (firstDetails) firstDetails.open = true;

        window.requestAnimationFrame(function () {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      } else {
        panel.classList.remove('is-expanded');
        panel.classList.add('dd-pdp-details--collapsed');
        trigger.setAttribute('aria-expanded', 'false');

        panel.querySelectorAll('details').forEach(function (details) {
          details.open = false;
        });
      }
    });
  }

  function initVariantMedia(section) {
    if (section.dataset.ddMediaInitialized === 'true') return;

    section.dataset.ddMediaInitialized = 'true';
    section.dataset.ddVariantMediaUserSelected = 'false';

    function activateFeaturedMedia(mediaId) {
      activateMediaItem(section, mediaId, true);
    }

    function syncFromSelectedVariant() {
      var variantSelects = section.querySelector('variant-selects');
      if (!variantSelects) return;

      var variantJson = variantSelects.querySelector('[data-selected-variant]');
      var selectedVariant = parseJsonScript(variantJson);

      if (selectedVariant && selectedVariant.featured_media) {
        activateFeaturedMedia(selectedVariant.featured_media.id);
      }
    }

    function getSelectedOptions(changedInput) {
      var variantSelects = section.querySelector('variant-selects');
      if (!variantSelects) return [];

      return Array.from(variantSelects.querySelectorAll('[data-dd-product-option]')).map(function (optionGroup) {
        if (changedInput && optionGroup.contains(changedInput)) {
          return changedInput.value;
        }

        var checkedInput = optionGroup.querySelector('input[type="radio"]:checked');
        if (checkedInput) return checkedInput.value;

        var selectedOption = optionGroup.querySelector('select option:checked');
        if (selectedOption) return selectedOption.value;

        var select = optionGroup.querySelector('select');
        if (select) return select.value;

        return '';
      });
    }

    function findSelectedVariant(changedInput) {
      var variantsJson = section.querySelector('[data-dd-product-variants]');
      var variants = parseJsonScript(variantsJson) || [];
      var selectedOptions = getSelectedOptions(changedInput);
      if (!selectedOptions.length || !variants.length) return null;

      return variants.find(function (variant) {
        if (!variant.options || variant.options.length !== selectedOptions.length) return false;

        return variant.options.every(function (optionValue, index) {
          return optionValue === selectedOptions[index];
        });
      });
    }

    function syncFromSelectedOptions(changedInput) {
      var selectedVariant = findSelectedVariant(changedInput);

      if (selectedVariant && selectedVariant.featured_media_id) {
        activateFeaturedMedia(selectedVariant.featured_media_id);
        return;
      }

      syncFromSelectedVariant();
    }

    function getInputFromEvent(event) {
      var input = event.target.closest && event.target.closest('input[type="radio"], select');
      if (input) return input;

      var label = event.target.closest && event.target.closest('label[for]');
      if (!label) return null;

      return section.querySelector('#' + CSS.escape(label.getAttribute('for')));
    }

    function scheduleSync(changedInput) {
      [0, 50, 150, 300].forEach(function (delay) {
        window.setTimeout(function () {
          syncFromSelectedOptions(changedInput);
        }, delay);
      });
    }

    function markUserSelectedVariant() {
      section.dataset.ddVariantMediaUserSelected = 'true';
    }

    section.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('variant-selects')) return;

      var input = getInputFromEvent(event);
      if (!input) return;

      markUserSelectedVariant();
      scheduleSync(input);
    });

    section.addEventListener('input', function (event) {
      if (!event.target.closest || !event.target.closest('variant-selects')) return;

      markUserSelectedVariant();
      scheduleSync(getInputFromEvent(event));
    });

    section.addEventListener('change', function (event) {
      if (!event.target.closest || !event.target.closest('variant-selects')) return;

      markUserSelectedVariant();
      scheduleSync(getInputFromEvent(event));
    });

    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || !variant.featured_media || !section.contains(event.target)) return;
      if (section.dataset.ddVariantMediaUserSelected !== 'true') return;

      activateFeaturedMedia(variant.featured_media.id);
    });

    var media = section.querySelector('[data-dd-pdp-media]');
    showAllMedia(media);

    [0, 100, 500, 1000].forEach(function (delay) {
      window.setTimeout(function () {
        if (section.dataset.ddVariantMediaUserSelected === 'true') return;

        showAllMedia(media);
      }, delay);
    });
  }

  function initMobileMediaPagination(section) {
    section.querySelectorAll('[data-dd-pdp-media]').forEach(function (media) {
      var grid = media.querySelector('.dd-pdp-media__grid');
      if (!grid || grid.dataset.ddMediaPaginationInitialized === 'true') return;

      grid.dataset.ddMediaPaginationInitialized = 'true';
      ensureMediaPagination(media);
      updateMediaPagination(media);

      var ticking = false;
      var touchStartX = 0;
      var touchStartY = 0;
      var touchStartIndex = 0;
      var isHorizontalSwipe = false;
      var hasTouch = false;

      function isMobileGallery() {
        return window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
      }

      function getNearestIndex() {
        var items = getOrderedMediaItems(media);
        if (!items.length) return 0;

        var gridRect = grid.getBoundingClientRect();
        var viewportCenter = gridRect.left + gridRect.width / 2;
        var nearestIndex = 0;
        var closestDistance = Infinity;

        items.forEach(function (item, index) {
          var itemRect = item.getBoundingClientRect();
          var itemCenter = itemRect.left + itemRect.width / 2;
          var distance = Math.abs(itemCenter - viewportCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      }

      function scrollToIndex(index, behavior) {
        var items = getOrderedMediaItems(media);
        if (!items.length) return;

        var nextIndex = Math.max(0, Math.min(index, items.length - 1));
        var targetItem = items[nextIndex];
        if (!targetItem) return;

        grid.scrollTo({ left: targetItem.offsetLeft, behavior: behavior || 'smooth' });
        window.setTimeout(function () {
          updateMediaPagination(media);
        }, 180);
      }

      function requestPaginationUpdate() {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          updateMediaPagination(media);
        });
      }

      grid.addEventListener(
        'touchstart',
        function (event) {
          if (!isMobileGallery() || !event.touches || !event.touches.length) return;

          hasTouch = true;
          isHorizontalSwipe = false;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          touchStartIndex = getNearestIndex();
        },
        { passive: true }
      );

      grid.addEventListener(
        'touchmove',
        function (event) {
          if (!hasTouch || !isMobileGallery() || !event.touches || !event.touches.length) return;

          var deltaX = event.touches[0].clientX - touchStartX;
          var deltaY = event.touches[0].clientY - touchStartY;

          if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
            isHorizontalSwipe = true;
            event.preventDefault();
          }
        },
        { passive: false }
      );

      grid.addEventListener(
        'touchend',
        function (event) {
          if (!hasTouch || !isMobileGallery()) return;

          hasTouch = false;
          var touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;

          var deltaX = touch.clientX - touchStartX;
          var deltaY = touch.clientY - touchStartY;

          if (!isHorizontalSwipe || Math.abs(deltaX) < 28 || Math.abs(deltaX) <= Math.abs(deltaY)) {
            scrollToIndex(getNearestIndex(), 'smooth');
            return;
          }

          scrollToIndex(touchStartIndex + (deltaX < 0 ? 1 : -1), 'smooth');
        },
        { passive: true }
      );

      grid.addEventListener('touchcancel', function () {
        hasTouch = false;
        isHorizontalSwipe = false;
      });

      grid.addEventListener('scroll', requestPaginationUpdate, { passive: true });
      window.addEventListener('resize', requestPaginationUpdate);
      window.setTimeout(requestPaginationUpdate, 250);
    });
  }

  function initMediaExpansion(section) {
    section.querySelectorAll('[data-dd-pdp-media]').forEach(function (media) {
      var button = media.querySelector('[data-dd-pdp-media-expand]');

      if (!media.dataset.ddActiveMediaId) showAllMedia(media);

      if (!button || button.dataset.ddMediaExpandInitialized === 'true') return;

      button.dataset.ddMediaExpandInitialized = 'true';

      button.addEventListener('click', function () {
        media.classList.add('is-expanded');
        media.classList.remove('dd-pdp-media--collapsed');
        applyMediaLimit(media);
        button.setAttribute('aria-expanded', 'true');
      });
    });
  }

  function initStoryVideos(section) {
    section.querySelectorAll('[data-dd-story-videos]').forEach(function (storyVideos) {
      if (storyVideos.dataset.ddStoryVideosInitialized === 'true') return;

      storyVideos.dataset.ddStoryVideosInitialized = 'true';

      var viewport = storyVideos.querySelector('[data-dd-story-videos-viewport]');
      var prevButton = storyVideos.querySelector('[data-dd-story-videos-prev]');
      var nextButton = storyVideos.querySelector('[data-dd-story-videos-next]');
      var modal = storyVideos.querySelector('[data-dd-story-video-modal]');
      var frame = storyVideos.querySelector('[data-dd-story-video-frame]');

      function getScrollStep() {
        var firstItem = storyVideos.querySelector('.dd-pdp-story-videos__item');
        if (!firstItem) return 160;

        return firstItem.getBoundingClientRect().width + 8;
      }

      function updateArrows() {
        if (!viewport || !prevButton || !nextButton) return;

        var maxScroll = viewport.scrollWidth - viewport.clientWidth;
        prevButton.disabled = viewport.scrollLeft <= 1;
        nextButton.disabled = viewport.scrollLeft >= maxScroll - 1;
      }

      function closeModal() {
        if (!modal || !frame) return;

        frame.querySelectorAll('video').forEach(function (video) {
          video.pause();
          video.removeAttribute('src');
          video.load();
        });
        frame.innerHTML = '';
        modal.hidden = true;
        document.documentElement.classList.remove('dd-story-video-open');
      }

      function openModal(templateId) {
        if (!modal || !frame || !templateId) return;

        var template = storyVideos.querySelector('#' + CSS.escape(templateId));
        if (!template) return;

        frame.innerHTML = '';
        frame.appendChild(template.content.cloneNode(true));
        modal.hidden = false;
        document.documentElement.classList.add('dd-story-video-open');

        var video = frame.querySelector('video');
        if (video && typeof video.play === 'function') {
          video.play().catch(function () {});
        }
      }

      prevButton?.addEventListener('click', function () {
        if (!viewport) return;

        viewport.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });

      nextButton?.addEventListener('click', function () {
        if (!viewport) return;

        viewport.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });

      viewport?.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateArrows);
      });

      storyVideos.addEventListener('click', function (event) {
        var openButton = event.target.closest && event.target.closest('[data-dd-story-video-open]');
        if (openButton && storyVideos.contains(openButton)) {
          openModal(openButton.dataset.ddStoryVideoTemplate);
          return;
        }

        var closeTarget = event.target.closest && event.target.closest('[data-dd-story-video-close]');
        if (closeTarget || event.target === modal) {
          closeModal();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !modal || modal.hidden) return;

        closeModal();
      });

      updateArrows();
      window.setTimeout(updateArrows, 200);
    });
  }

  function initDDMainProduct(root) {
    (root || document).querySelectorAll('[data-dd-pdp]').forEach(function (section) {
      try {
        initDetails(section);
      } catch (error) {
        console.warn('DD PDP details init failed', error);
      }

      try {
        initVariantMedia(section);
      } catch (error) {
        console.warn('DD PDP media init failed', error);
      }

      try {
        initMediaExpansion(section);
      } catch (error) {
        console.warn('DD PDP media expansion init failed', error);
      }

      try {
        initMobileMediaPagination(section);
      } catch (error) {
        console.warn('DD PDP mobile media pagination init failed', error);
      }

      try {
        initStoryVideos(section);
      } catch (error) {
        console.warn('DD PDP story videos init failed', error);
      }
    });
  }

  window.initDDMainProduct = initDDMainProduct;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDDMainProduct(document);
    });
  } else {
    initDDMainProduct(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initDDMainProduct(event.target);
  });
})();
